<script setup lang="ts">
const imageList = ref<HTMLElement>();
const images = ref<HTMLImageElement[]>([]);

let currentImageCount = 0;

onMounted(() => {
  images.value = imageList.value!.getElementsByTagName("img");
  images.value[currentImageCount].classList.add("fade-in");

  setInterval(imageTransition, 5000);
});

function imageTransition() {
  images.value[currentImageCount].classList.remove("fade-in");
  if (currentImageCount < images.value.length - 1) {
    currentImageCount++;
  } else {
    currentImageCount = 0;
  }
  images.value[currentImageCount].classList.add("fade-in");
}
</script>

<template>
  <div ref="imageList" class="image-montage">
    <slot />
  </div>
</template>

<style lang="scss">
.image-montage {
  height: 100%;
  position: relative;

  img {
    height: 300px;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    transition: opacity 1s;
    width: 100%;

    &.fade-in {
      opacity: 1;
    }
  }
}
</style>
